/**
 * Chrome material theme, exposed as one flat list of modes but driven by two
 * independent axes: how much of the chrome is moulded, and what pigment the
 * plastic has. Applied to <html> as `data-material` (scope) and
 * `data-material-tone` (pigment); `src/lab.css` owns the --plastic-* tokens,
 * `@theme` bridge, and `[data-material=*]` faceplate layers.
 */
export const MATERIAL_MODES = ["flat", "bar", "full", "full-warm"] as const;

export type MaterialMode = typeof MATERIAL_MODES[number];

type MaterialScope = "flat" | "bar" | "full";
type MaterialTone = "cool" | "warm";

const MATERIAL_AXES: Record<MaterialMode, { scope: MaterialScope; tone: MaterialTone }> = {
  "flat": { scope: "flat", tone: "cool" },
  "bar": { scope: "bar", tone: "cool" },
  "full": { scope: "full", tone: "cool" },
  "full-warm": { scope: "full", tone: "warm" },
};

export const DEFAULT_MATERIAL: MaterialMode = "full";

export const MATERIAL_OPTIONS: readonly {
  id: MaterialMode;
  label: string;
}[] = [
  { id: "flat", label: "Flat" },
  { id: "bar", label: "Plastic menu" },
  { id: "full", label: "Plastic full" },
  { id: "full-warm", label: "Plastic warm" },
];

export function isMaterialMode(value: unknown): value is MaterialMode {
  return typeof value === "string" && (MATERIAL_MODES as readonly string[]).includes(value);
}

export function applyMaterial(mode: MaterialMode, root: HTMLElement): void {
  const { scope, tone } = MATERIAL_AXES[mode];
  root.dataset.material = scope;
  root.dataset.materialTone = tone;
}
